import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

import { getBatchFiles } from 'actions';

class BatchFilesRedirectButton extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    batchId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]).isRequired,
    content: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]).isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    title: '',
    className: '',
    disabled: false
  };

  onClick(history) {
    const { batchId, dispatch } = this.props;
    dispatch(getBatchFiles(batchId, 1, 50, '', '', ''));
    history.push(`/batches/${ batchId }/files`);
  }

  render() {
    const { content, className, title, disabled } = this.props;
    return <Route
      render={ ({ history }) => (
        <button
          type="button"
          className={ `${ className }` }
          onClick={ () => this.onClick(history) }
          title={ title }
          disabled={ disabled }
        >
          { content }
        </button>
      ) }
    />;
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

export const BatchFilesButton = connect(
  null,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(BatchFilesRedirectButton);

export default BatchFilesButton;
